// Lib
import { useDispatch } from 'react-redux';
import { List } from 'immutable';

// Utils
import { getTags } from '../../../../../../../common/elements/utils/elementPropertyUtils';

// Actions
import { removeTagFromElements } from '../../../../../../element/tags/elementTagActions';
import { addTagToElementsThunk, createAndAddTagToElementsThunk } from '../tagThunks';

// Types
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { TagsToolContentProps } from '../TagsToolContent';

type ReturnType = {
    handleToggleTagSelection: (tag: Tag) => void;
    handleCreateTag: (rootBoardId?: string) => void;
    handleCreateCopyAndAddToElement: (tag: Tag) => void;
};

const useTagHandlers = (
    props: TagsToolContentProps,
    searchString: string,
    setSearchString: (searchString: string) => void,
    elements: List<ImMNElement>,
): ReturnType => {
    const { currentBoardId, selectedElements, currentUserId, closePopup, shareRootPath } = props;

    const dispatch = useDispatch();

    const handleAddTagToElements = (tag: Tag) => {
        dispatch(addTagToElementsThunk(tag, elements, currentBoardId, shareRootPath));
    };

    const handleToggleTagSelection = (tag: Tag) => {
        if (elements.every((element) => getTags(element)?.includes(tag.id))) {
            dispatch(removeTagFromElements(elements, tag.id));
        } else {
            handleAddTagToElements(tag);
        }

        // If the user is filtering the tags close the popup when they select a tag
        if (searchString) closePopup();
    };

    const handleCreateTag = (rootBoardId = currentBoardId) => {
        if (!searchString) return;

        const tagData = {
            name: searchString,
            rootBoardIds: [rootBoardId],
            creator: currentUserId,
        };

        dispatch(createAndAddTagToElementsThunk(tagData, selectedElements, currentBoardId, shareRootPath));

        setSearchString('');
        closePopup();
    };

    const handleCreateCopyAndAddToElement = (tag: Tag) => {
        const { name, color } = tag;
        const tagData = {
            name,
            color,
            rootBoardIds: [currentBoardId],
            creator: currentUserId,
        };

        dispatch(createAndAddTagToElementsThunk(tagData, selectedElements, currentBoardId, shareRootPath));
    };

    return {
        handleToggleTagSelection,
        handleCreateTag,
        handleCreateCopyAndAddToElement,
    };
};

export default useTagHandlers;
